'use client';

import { COLORS } from '@/constants';
import { Box } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled.section<{ $bgColor?: keyof typeof COLORS }>`
  position: relative;
  background: ${(props) => (props.$bgColor ? COLORS[props.$bgColor] : COLORS.white)};
  width: 100%;
  overflow: clip;
`;

export const Container = styled.div<{ $isRelative?: boolean }>`
  margin: 0 auto;
  max-width: 1182px;
  padding: 65px 30px;
  position: relative;
  z-index: 5;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }

  @media (max-width: 480px) {
    padding: 28px 12px;
  }
`;

export const Head = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 30px;
  width: 100%;

  @media (max-width: 800px) {
    margin-bottom: 20px;
  }
`;
